import { render, staticRenderFns } from "./supplyList.vue?vue&type=template&id=1dbf8561&scoped=true&"
import script from "./supplyList.vue?vue&type=script&lang=js&"
export * from "./supplyList.vue?vue&type=script&lang=js&"
import style0 from "./supplyList.vue?vue&type=style&index=0&id=1dbf8561&scoped=true&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbf8561",
  null
  
)

component.options.__file = "supplyList.vue"
export default component.exports